// export layout related constants
export const LAYOUT = 'vertical';

export const LAYOUT_MODE = 'light';

export const LAYOUT_WIDTH = 'fluid';

export const LAYOUT_POSITION = 'fixed';

export const TOPBAR = 'light';

export const SIDEBAR_SIZE = 'sm-hover-active';

export const SIDEBAR_VIEW = 'default';

export const SIDEBAR_COLOR = 'dark';

export const SIDEBAR_IMAGE = 'none';

export const SIDEBAR_VISIBILITY = 'show';

export const DATA_PRELOADER = 'enabled';
